import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

// ADMIN ROUTE
const createBundle = async (bundleData) => {
  try {
    const token = getAuthToken();
    const data = await api.post("/bundle/create", bundleData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.data;
  } catch (err) {
    throw err;
  }
};

// ADMIN ROUTE
const updateBundle = async (bundleId, bundleData) => {
  try {
    const token = getAuthToken();
    const data = await api.put(`/bundle/${bundleId}`, bundleData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.data;
  } catch (err) {
    throw err;
  }
};

// ADMIN ROUTE
const deleteBundle = async (bundleId) => {
  try {
    const token = getAuthToken();
    const data = await api.delete(`/bundle/${bundleId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.data;
  } catch (err) {
    throw err;
  }
};

// USER ROUTE
const getBundles = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get(`/bundles`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.data;
  } catch (err) {
    throw err;
  }
};

// USER ROUTE
const getProductBundles = async (productId) => {
  try {
    // console.log("product id to be: ", productId);
    const token = getAuthToken();
    const data = await api.get(`/bundles/product/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("data from be: ", data.data);
    return data.data;
  } catch (err) {
    throw err;
  }
};

// USER ROUTE
const getBundleById = async (bundleId) => {
  try {
    const token = getAuthToken();
    const data = await api.get(`/bundle/${bundleId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

// USER ROUTE
const getActiveBundles = async () => {
  try {
    const token = getAuthToken();
    const data = await api.get(`/bundles/active`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

export {
  createBundle,
  updateBundle,
  deleteBundle,
  getBundles,
  getProductBundles,
  getBundleById,
  getActiveBundles,
};
